var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Faq"}},[_c('Hero',{staticClass:"lift",attrs:{"formats":['webp'],"src":"../../../assets/faq-hero.jpg"}},[_c('Wrap',[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")])])],1),_c('SectionFaq',{attrs:{"doShowHeadline":false,"doShowAllQuestions":"","faqs":_vm.faqs}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }